module.exports = __webpack_public_path__ + "static/32-92712813afb284224fc7fe0ee54d4bf7.jpg";